var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h3',[_vm._v("Thank you - You Have Signed Out")]),_c('br'),_c('b-button',{on:{"click":function($event){return _vm.goLogin()}}},[_vm._v("Log In")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }